module.exports = __webpack_public_path__ + "img/print_check_checked.936e7834.svg";